<template>
    <div class="flex sm:flex-wrap md:flex-no-wrap gap-x-5">
        <div class="sm:w-full md:w-4/12 lg:w-3/12 sm:block md:sticky stickie">
            <slot name="filter">
                <vx-card class="relative">
                    <vs-progress class="topper" v-show="busy"
                        :height="2" indeterminate color="primary">primary</vs-progress>
                        <BaseFilter
                            skipRangeValidation
                            @filter="(v) => $emit('filter', v)">
                            <template slot="before-date">
                                <slot name="filter-before-date" />
                            </template>
                            <template slot="after-date">
                                <slot name="filter-after-date" />
                            </template>
                        </BaseFilter>
                </vx-card>
            </slot>
        </div>
        <div class="sm:w-full md:w-8/12 lg:w-9/12 sm:mt-4 md:mt-0">
            <slot />
        </div>
    </div>
</template>

<script>
import BaseFilter from '../components/BaseFilter.vue'
import Template from '../components/table/templates/one/Template.vue'
    export default {
        components: {
            BaseFilter,
                Template,
        },
        props: {
            busy: Boolean
        },
    }
</script>

<style lang="scss" scoped>

.topper {
    position: absolute;
    top: 0;
    left: 4px;
    right: 4px;
    width: calc(100% - 8px);
}
.stickie {
    top: 76px;
    height: fit-content;
}
</style>